export const MAX_ATTENDANCES_ROWS = 2

export const MAX_ABSENCES_ROWS = 1
